const convertToLiters = (ml) => {
  if (ml >= 1000) {
    const liters = ml / 1000;
    return liters + " L";
  } else {
    return ml + " ml";
  }
};
export default convertToLiters;
